import { PageModule } from 'app/pages/types';
import React from 'react';
import Password from './Password';

export const PasswordPageModule: PageModule = {
  pageIf: (page, exception) => !exception && page === 'password',
  render: () => <Password />
};
